export const STRAAT = "Hanzeweg 12D";
export const POSTCODE = "2803 MC";
export const PLAATS = "Gouda";